import { maybePlayChatSound } from '../../utils/soundUtils';
import { addPanelUpdate } from './panelsActions';
export const CLEAR_CHAT_ITEMS = 'CLEAR_CHAT_ITEMS';
export const ADD_PLAYER_MESSAGE_CHAT_ITEM_FROM_INBOUND = 'ADD_PLAYER_MESSAGE_CHAT_ITEM_FROM_INBOUND';
export const ADD_HTML_CHAT_ITEM = 'ADD_HTML_CHAT_ITEM';
export const ADD_ACTION_RESULT_CHAT_ITEM = 'ADD_ACTION_RESULT_CHAT_ITEM';
export const ADD_ACTION_ERROR_CHAT_ITEM = 'ADD_ACTION_ERROR_CHAT_ITEM';
export const ADD_PLAYER_ENTER_CHAT_ITEM = 'ADD_PLAYER_ENTER_CHAT_ITEM';
export const ADD_PLAYER_LEAVE_CHAT_ITEM = 'ADD_PLAYER_LEAVE_CHAT_ITEM';
export const ADD_HAND_REVEAL_CHAT_ITEM = 'ADD_HAND_REVEAL_CHAT_ITEM';
export const SET_BLOCKED_CHAT_PLAYERS_FROM_INBOUND = 'SET_BLOCKED_CHAT_PLAYERS_FROM_INBOUND';
export function clearChatItems() {
    return {
        type: CLEAR_CHAT_ITEMS
    };
}
function addPlayerMessageChatItemFromInbound(inbound) {
    return {
        type: ADD_PLAYER_MESSAGE_CHAT_ITEM_FROM_INBOUND,
        payload: inbound
    };
}
export function thunkAddPlayerMessageChatItemFromInbound(inbound) {
    return function (dispatch, getState) {
        const state = getState();
        maybePlayChatSound(state);
        dispatch(addPlayerMessageChatItemFromInbound(inbound));
        if (state.panels.activePanelType !== 'chat') {
            dispatch(addPanelUpdate('chat'));
        }
    };
}
export function addHtmlChatItem(html) {
    return {
        type: ADD_HTML_CHAT_ITEM,
        payload: html
    };
}
export function addActionResultChatItem(html) {
    return {
        type: ADD_ACTION_RESULT_CHAT_ITEM,
        payload: html
    };
}
export function addActionErrorChatItem(html) {
    return {
        type: ADD_ACTION_ERROR_CHAT_ITEM,
        payload: html
    };
}
export function addPlayerEnterChatItem(html) {
    return {
        type: ADD_PLAYER_ENTER_CHAT_ITEM,
        payload: html
    };
}
export function addPlayerLeaveChatItem(html) {
    return {
        type: ADD_PLAYER_LEAVE_CHAT_ITEM,
        payload: html
    };
}
export function addHandRevealChatItem(username, handName, cards, communityCards, rabbits) {
    return {
        type: ADD_HAND_REVEAL_CHAT_ITEM,
        payload: { username, handName, cards, communityCards, rabbits }
    };
}
export function setBlockedChatPlayersFromInbound(inbound) {
    return {
        type: SET_BLOCKED_CHAT_PLAYERS_FROM_INBOUND,
        payload: inbound
    };
}
